
import { mergeMap, filter } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { empty, of } from 'rxjs'
import { TOGGLE_DISMISS_INSIGHT } from 'actions/insightsActions'
import { Epic } from 'interfaces/middleware'
import { captureForgottenGuard } from 'helpers/errorHelpers'
import { opportunitiesSelector, createRawFilteredOpportunitiesSelector } from 'selectors/oppertunitiesSelectors'
import { TOP_CATEGORY_ID } from 'constants/meta'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { SET_FILTER_CATEGORY, setFilterCategoryActionCreator } from 'actions/globalActions'
import { sortOpportunitiesActionCreator } from 'actions/opportunityActions'
import { isOpportunityPageInsight } from 'helpers/insightHelpers'
import { OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'
import { createSelectedCategoryIdSelector } from 'selectors/globalSelectors'
import { isCategoryPredefined } from 'helpers/opportunityHelpers'
import { byType } from 'rxOperators/byType'

const rawFilteredOpportunitiesSelector = createRawFilteredOpportunitiesSelector()
const selectedCategoryIdSelector = createSelectedCategoryIdSelector()
const resetOpportunityCategoryEpic: Epic = (action$, store) =>
  action$
    .pipe(byType(TOGGLE_DISMISS_INSIGHT)).pipe(
      filter((action) =>
        action.payload.is_dismissed === true
      && isOpportunityPageInsight(action.payload.insight)
      ),
      mergeMap(() => {
        const state = store.getState()
        const opportunities = rawFilteredOpportunitiesSelector(state, { placement: OPPORTUNITIES_PAGE_PLACEMENT })
        const selectedCategoryId = selectedCategoryIdSelector(state, OPPORTUNITIES_PAGE)
        const isSelectedCategoryVirtual = isCategoryPredefined(selectedCategoryId)

        if (!opportunities) {
          captureForgottenGuard('resetOpportunityCategoryEpic', 'rawFilteredOpportunitiesSelector')
          return empty()
        }

        return opportunities.length || isSelectedCategoryVirtual
          ? empty()
          : of(setFilterCategoryActionCreator(OPPORTUNITIES_PAGE, TOP_CATEGORY_ID))
      }))

const setFilterCategoryEpic: Epic = (action$, store) =>
  action$
    .pipe(byType(SET_FILTER_CATEGORY)).pipe(
      mergeMap(() => {
        const opportunities = opportunitiesSelector(store.getState())

        return opportunities
          ? of(sortOpportunitiesActionCreator(opportunities))
          : empty()
      }))

export default combineEpics(
  resetOpportunityCategoryEpic,
  setFilterCategoryEpic,
)
